//@flow

import React, { useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Form } from '@sharingapples/form';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import differenceInDays from 'date-fns/difference_in_calendar_days';
import { Head } from '@dom/components';

import { useSelector } from '../../redux';

import Guide from './Guide';
import GuideFiltersGroup from './GuideFiltersGroup';
import { GuideSearchModify } from '../common';
import PorterGuide from './PorterGuide';
import GuideSortButton from './GuideSortButton';
import GuideFilterButton from './GuideFilterButton';
import ListProperty from './ListProperty';

import { WhitePanelLayout } from './imports';
import { DesktopComponent, MobileComponent,  } from '../../components';
import { BookingNotAvailableModal } from '../../components/MessageModals';

import { getGuideSearchQuery, getFilteredGuideIds, getGuideSearchFilters } from '../../redux/selectors';
import { updateGuideSearchQuery, updateGuideSearchFilter } from '../../redux/actors';

import { useFetchGuideList } from '../../api/fetchGuideList';

import './guideListing.scss';
import { isBookingDateValid } from '../../utils';

const initiaValues = {
  pax: 1,
  numberOfDays: 1,
};

function GuideListing(props) {
  const [isMessageModalVisible, setModalVisibility] = useState(null);
  const closeMessage = () => setModalVisibility(false);
  const openMessage = () => setModalVisibility(true);

  useFetchGuideList();

  const { location } = props;
  const filteredGuideIds = useSelector(getFilteredGuideIds);

  // Get guide search filter and query from redux
  const guideSearchFilterInitialValue = useSelector(getGuideSearchFilters) || { languages: [], };
  const guideSearchQuery = useSelector(getGuideSearchQuery);

  // Get guide search query from url
  const urlQuery = queryString.parse(location.search);
  const { baseCity } = urlQuery;

  if (baseCity) guideSearchFilterInitialValue.baseCity = baseCity;

  // Merge Query from Redux and Url to get Inital Value for form.
  const guideSeachQueryInitialValue = {
    ...initiaValues,
    ...urlQuery,
    ...guideSearchQuery,
  };
  const trekName = guideSeachQueryInitialValue.guideQuery;

  // Function to Update redux state and url when user modifies search query.
  const updateGuideSearchState = state => {
    const { guideQuery: trek, startDate, endDate, pax } = state;

    if (isBookingDateValid(startDate)) {
      const numberOfDays = differenceInDays(endDate, startDate) + 1;

      updateGuideSearchQuery({ ...state, numberOfDays });
      return props.history.replace(`/list?${queryString.stringify({ trek, startDate, endDate, pax, baseCity })}`);
    } else {
      openMessage();
    }
  }

  return (
    <Head title={`Trekking Guide and Porter-Guides for ${trekName}`}>
      <BookingNotAvailableModal isOpen={isMessageModalVisible} close={closeMessage} />
      <Container>
        <Row>
          <Col lg="3" xs="12">
            <DesktopComponent>
              <Form defaultValue={guideSearchFilterInitialValue} onChange={updateGuideSearchFilter}>
                <WhitePanelLayout>
                  <GuideFiltersGroup />
                </WhitePanelLayout>
              </Form>
            </DesktopComponent>
              <ListProperty isMobile/>
          </Col>
          <Col lg="9" xs="12">
            <Form defaultValue={guideSeachQueryInitialValue} onSubmit={updateGuideSearchState}>
              <div className="result-header">
                <h1 className="result-title">Trekking Guide and Porter-Guides {trekName && 'for'} {trekName}</h1>
                <GuideSortButton />
                <MobileComponent>
                  <Form defaultValue={guideSearchFilterInitialValue} onChange={updateGuideSearchFilter}>
                    <GuideFilterButton />
                  </Form>
                </MobileComponent>
              </div>
              <GuideSearchModify />
              <h5>Request a Porter-Guide</h5>
              <PorterGuide />
            </Form>
            {(filteredGuideIds && filteredGuideIds.length !== 0) && <h5>Request a Guide</h5>}
            {
              filteredGuideIds && filteredGuideIds.map(id => <Guide key={id} id={id} />)
            }
          </Col>
        </Row>
      </Container>
    </Head>
  );
}

export default withRouter(GuideListing);
